/**
 * Delivery estimate (snippets/delivery-estimate.liquid), on the product page and the cart page.
 * <delivery-estimate data-min data-max data-template> turns the server's "Arrives in 4 to 10 business
 * days" in its [data-delivery-estimate] into dates counted from today in the shopper's browser, for
 * example "Arrives Fri, Oct 24 to Mon, Nov 3". Saturdays and Sundays are not counted, and the dates
 * are written in the page language (the html lang). The element also gets data-start and data-end as
 * YYYY-MM-DD. The cart page re-renders its section after each change; the new element fills itself.
 */
(function () {
  if (customElements.get('delivery-estimate')) return;

  const FORMAT = { weekday: 'short', month: 'short', day: 'numeric' };

  // The day that is `days` business days after `from`, skipping Saturday and Sunday.
  function addBusinessDays(from, days) {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return date;
  }

  const pad = (n) => String(n).padStart(2, '0');
  const isoDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  function formatter() {
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || undefined, FORMAT);
    } catch (e) {
      return new Intl.DateTimeFormat(undefined, FORMAT);
    }
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('[data-delivery-estimate]');
      const min = parseInt(this.dataset.min, 10);
      const max = parseInt(this.dataset.max, 10);
      const template = this.dataset.template;
      if (!text || !template || !(min >= 1) || !(max >= min)) return;

      const today = new Date();
      const start = addBusinessDays(today, min);
      const end = addBusinessDays(today, max);
      const format = formatter();
      text.textContent = template.replace('[start]', format.format(start)).replace('[end]', format.format(end));
      this.dataset.start = isoDay(start);
      this.dataset.end = isoDay(end);
    }
  }

  customElements.define('delivery-estimate', DeliveryEstimate);
})();
